import { useParams } from 'react-router';

import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PolicyPagePrefetchedDataProps } from 'src/app/pages/legal/policy/pageContext';
import { PolicyPageContextProvider, prefetchPageContext } from 'src/app/pages/legal/policy/pageContext';

import { Layout } from '../layout';

import { PolicyErrorHandler } from './ErrorHandler';

export const Policy = withPrefetchedData(
	function Policy({ prefetchedData }: PolicyPagePrefetchedDataProps) {
		const { slug } = useParams();

		return (
			<PolicyPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PolicyErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</PolicyPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context.params.slug, context),
	},
);
